import { capitalize } from "lodash";

export function splitFlagReason(reason: string): string {
  return reason
    .split("-")
    .map((s) => capitalize(s))
    .join(" ");
}
